export enum PreloaderBackgroundType {
    Default = 'preloader_background_default',
    Halloween = 'preloader_background_halloween'
}
